import React from 'react';
import Icon from '../../../components/AppIcon';

const ActiveSessionsPanel = () => {
  // Mock data - replace with real session data from Supabase
  const activeSessions = [
    {
      id: 1,
      user: 'admin@sailorsbailbonds.com',
      location: 'Sacramento, CA',
      device: 'Chrome on Windows',
      lastActive: new Date(Date.now() - 1000 * 60 * 5), // 5 minutes ago
      isCurrent: true
    },
    {
      id: 2,
      user: 'agent@sailorsbailbonds.com',
      location: 'San Francisco, CA',
      device: 'Safari on macOS',
      lastActive: new Date(Date.now() - 1000 * 60 * 15), // 15 minutes ago
      isCurrent: false
    }
  ];

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    
    if (seconds < 60) return 'Active now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
  };

  const handleTerminateSession = (sessionId) => {
    console.log('Terminating session:', sessionId);
    // Implement session termination logic
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-soft overflow-hidden">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-semibold text-foreground">Active Sessions</h3>
            <p className="text-xs text-muted-foreground mt-1">
              {activeSessions?.length} active session{activeSessions?.length !== 1 ? 's' : ''}
            </p>
          </div>
          <div className="w-2 h-2 bg-accent rounded-full animate-pulse"></div>
        </div>
      </div>

      <div className="divide-y divide-border">
        {activeSessions?.map((session) => (
          <div key={session?.id} className="p-4 hover:bg-muted/20 transition-colors">
            <div className="flex items-start justify-between">
              <div className="flex items-start space-x-3 flex-1">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Monitor" size={14} color="var(--color-primary)" />
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <p className="text-xs font-medium text-foreground truncate">
                      {session?.user}
                    </p>
                    {session?.isCurrent && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-accent/10 text-accent">
                        Current
                      </span>
                    )}
                  </div>
                  
                  <div className="mt-1 space-y-1">
                    <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                      <Icon name="MapPin" size={12} />
                      <span>{session?.location}</span>
                    </div>
                    
                    <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                      <Icon name="Smartphone" size={12} />
                      <span>{session?.device}</span>
                    </div>
                    
                    <p className="text-xs text-muted-foreground">
                      {formatTimeAgo(session?.lastActive)}
                    </p>
                  </div>
                </div>
              </div>

              {!session?.isCurrent && (
                <button
                  onClick={() => handleTerminateSession(session?.id)}
                  className="p-2 text-error hover:bg-error/10 rounded-lg transition-colors ml-2"
                  title="Terminate Session"
                >
                  <Icon name="XCircle" size={14} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="p-3 border-t border-border bg-muted/30">
        <button className="w-full text-xs text-primary hover:text-primary/80 font-medium transition-colors">
          View All Sessions
        </button>
      </div>
    </div>
  );
};

export default ActiveSessionsPanel;